import styled from 'styled-components';

export const PageWrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 64px);
  background: ${({ theme }) => theme.landing.background};
  padding: 96px ${({ theme }) => theme.landingSpacing.xl} ${({ theme }) => theme.landingSpacing.xl};
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    padding: 64px ${({ theme }) => theme.landingSpacing.md}
      ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const ActionsBar = styled.div`
  width: 100%;
  max-width: 820px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.landingSpacing.md};
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  background: ${({ $primary, theme }) => ($primary ? theme.landing.buttonBg : 'transparent')};
  color: ${({ $primary }) => ($primary ? '#fff' : 'inherit')};
  border: 1px solid
    ${({ $primary, theme }) => ($primary ? theme.landing.buttonBg : theme.landing.cardBorder)};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover:not(:disabled) {
    background: ${({ $primary, theme }) =>
      $primary ? theme.landing.buttonHover : theme.landing.iconBg};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const InvoicePaper = styled.div`
  width: 100%;
  max-width: 820px;
  background: #ffffff;
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 8px 24px rgba(0, 0, 0, 0.06);
  padding: 40px 48px;
  color: #1a202c;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    padding: 28px 20px;
  }
`;

export const InvoiceHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.landingSpacing.md};
  flex-wrap: wrap;
`;

export const CompanyName = styled.h1`
  font-weight: 700;
  font-size: 1.5rem;
  margin: 0;
  color: #1a202c;
`;

export const InvoiceMetaBlock = styled.div`
  text-align: right;
  font-size: 0.9rem;
  color: #4a5568;
  line-height: 1.6;

  strong {
    color: #1a202c;
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 24px 0;
`;

export const TwoColumnSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => theme.landingSpacing.lg};
  margin-bottom: 32px;

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.landingSpacing.md};
  }
`;

export const AddressBlock = styled.div`
  text-align: ${({ $align }) => $align || 'left'};
`;

export const AddressLabel = styled.p`
  font-weight: 700;
  font-size: 0.85rem;
  color: #2b6cb0;
  margin: 0 0 6px 0;
`;

export const AddressLine = styled.p`
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #2d3748;

  a {
    color: #2b6cb0;
    text-decoration: none;
  }
`;

export const SectionTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 32px;
  font-size: 0.9rem;

  thead th {
    text-align: left;
    background: #f7f8fa;
    color: #1a202c;
    font-weight: 600;
    padding: 10px 14px;
    border: 1px solid #edf0f3;
  }

  thead th:last-child,
  tbody td:last-child {
    text-align: right;
  }

  tbody td {
    padding: 10px 14px;
    border: 1px solid #edf0f3;
    color: #2d3748;
  }
`;

export const LineItemsTable = styled(SectionTable)`
  thead th:nth-child(2),
  tbody td:nth-child(2),
  thead th:nth-child(3),
  tbody td:nth-child(3) {
    text-align: right;
    width: 130px;
  }
`;

export const TotalsSection = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
`;

export const TotalsTable = styled.div`
  width: 260px;
  font-size: 0.9rem;
`;

export const TotalsRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  color: ${({ $bold }) => ($bold ? '#1a202c' : '#4a5568')};
  font-weight: ${({ $bold }) => ($bold ? 700 : 400)};
  border-top: ${({ $bold }) => ($bold ? '2px solid #1a202c' : 'none')};
  margin-top: ${({ $bold }) => ($bold ? '4px' : '0')};
`;

export const NotesSection = styled.div`
  margin-bottom: 24px;
`;

export const NotesLabel = styled.p`
  font-weight: 700;
  font-size: 0.85rem;
  margin: 0 0 4px 0;
  color: #1a202c;
`;

export const NotesText = styled.p`
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #1a202c;
`;

export const Footer = styled.div`
  text-align: center;
  font-size: 0.8rem;
  color: #1a202c;
  border-top: 1px solid #1a202c;
  padding-top: 16px;
`;

export const StatusState = styled.div`
  width: 100%;
  max-width: 820px;
  background: #fff;
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: ${({ theme }) => theme.landingSpacing.xl};
  text-align: center;
  color: #4a5568;
`;
